module.exports = __webpack_public_path__ + "static/media/productNotAvailableBackground.94e1069a.jpg";